angular.module('app').factory('logoService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var logo = restAngular.all("/logo/");

        return {
            saveLogo: function (requestData) {
                return logo.
                one("apply").
                post("", requestData)
            },
            loadLogo: function () {
                return logo.
                one("get").
                get()
            }
        }
    }
]);